<template>
    <div class="home" style="text-align: center">
        <Head></Head>
        <slot/>
        <main-footer></main-footer>
        <div id="vk_community_messages"></div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Head from "../components/home/Head";

    export default {
        name: 'MainPageLayout',
        components: {
            Head
        },
        mounted() {
            var mode = process.env.NODE_ENV;
            if(mode == "production"){
                let script = "VK.Widgets.CommunityMessages('vk_community_messages', 115982637, {tooltipButtonText: 'Есть вопрос?'});"
                let VKScript = document.createElement('script')
                VKScript.text = script
                document.body.appendChild(VKScript)


            }
        }
    }
</script>
